/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseRegisterEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('COURSE_REGISTER_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class CourseRegisterEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseRegisterEnabledSettingParser.decode(input).map(res => new CourseRegisterEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return CourseRegisterEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseRegisterEnabledSettingParser.encode(data);
    }
    static schema() {
        return CourseRegisterEnabledSettingParser.schema();
    }
}
